import React, { useState, useEffect, useRef } from "react";

// Utilities
import moment from "moment";

// UI Components
import DateTime from "react-datetime";
import { InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons";

const SelectDateTime = ({ name, value, onChange, hideTime, children, ...props }) => {
  const inputRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [displayDate, setDisplayDate] = useState(moment(value));

  useEffect(() => {
    // Close input if user clicks outside
    function handleClickOutside(event) {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [inputRef]);

  const onSelectDate = (value) => {
    setDisplayDate(value);

    // Ensure only valid dates sent to state - otherwise breaks UI
    moment.isMoment(value) && onChange(value);
  };

  return (
    <div ref={inputRef}>
      <InputGroup className="d-flex">
        <InputGroupAddon addonType="prepend">
          <InputGroupText style={{ width: "80px" }}>{name}</InputGroupText>
        </InputGroupAddon>

        <DateTime
          className="flex-fill"
          utc={false}
          open={isOpen}
          value={displayDate}
          dateFormat="MMM DD, YYYY"
          timeFormat={hideTime ? false : "h:mm:ss A"}
          closeOnTab={true}
          closeOnSelect={false}
          // Events
          onChange={onSelectDate}
          onFocus={() => setIsOpen(true)}
          onBlur={() => setIsOpen(false)}
          {...props}
        />

        <InputGroupAddon addonType="append" onClick={() => setIsOpen(!isOpen)}>
          <InputGroupText>
            <FontAwesomeIcon icon={faCalendarAlt} />
          </InputGroupText>
        </InputGroupAddon>
      </InputGroup>

      {children}

      {!moment.isMoment(displayDate) && (
        <small className="text-danger">Please select a valid date</small>
      )}
    </div>
  );
};

export default SelectDateTime;
